// extracted by mini-css-extract-plugin
module.exports = {"score":"_1K855ol2MmsAWpPSgI-U4F","label":"_1IPhh12gWCf2ZtPNl629gx","value":"_2VMSwUKSciDnDb-24aNiK"};